import { render } from "./ModalLiked.vue?vue&type=template&id=bd6446b4&scoped=true"
import script from "./ModalLiked.vue?vue&type=script&lang=js"
export * from "./ModalLiked.vue?vue&type=script&lang=js"

import "@/components/home/home-public/middle.css?vue&type=style&index=0&id=bd6446b4&scoped=true&lang=css&external"
import "@/components/home/home-public/article-details.css?vue&type=style&index=1&id=bd6446b4&scoped=true&lang=css&external"
import "./ModalLiked.vue?vue&type=style&index=2&id=bd6446b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6446b4"]])

export default __exports__